import { useQuery } from '@tanstack/react-query';
import { getJson, postJson } from '../../../shared/api/client';
import { settingsKeys } from '../../../shared/api/cacheKeys';

export async function fetchSettings() {
  try {
    return getJson('/settings');
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

export function useSettingsQuery(options = {}) {
  return useQuery({ queryKey: settingsKeys.profile(), queryFn: fetchSettings, ...options });
}

export async function fetchDesignPreferences() {
  return getJson('/settings/design-preferences');
}

export async function updateDesignPreferences(payload) {
  return postJson('/settings/design-preferences', payload);
}

export async function fetchVisibilityPreferences() {
  return getJson('/settings/ui-visibility');
}

export async function updateVisibilityPreferences(payload) {
  return postJson('/settings/ui-visibility', payload);
}

export async function fetchWorkspaceShowcase() {
  return getJson('/settings/showcase');
}

export async function updateWorkspaceShowcase(payload) {
  return postJson('/settings/showcase', payload);
}

export async function fetchWorkspaceAiSettings() {
  return getJson('/settings/ai');
}

export async function updateWorkspaceAiSettings(payload) {
  return postJson('/settings/ai', payload);
}
